/**
 * MAGSDK basic implementation of browser plugin.
 */

'use strict';

var listener;


/**
 * @constructor
 *
 * @param {Object} config - data for constructor
 */
function Browser ( config ) {
    var self = this;

    this.isKilled = false;
    this.standalone = (config.options || {}).standalone;

    /**
     * Get message from browser engine
     */
    Object.defineProperty(this, 'onMessageReceive', { // eslint-disable-line
        set: function ( callback ) {
            stbEvent.addListener('message', listener = function ( event ) {
                var messagesToApp = self.messages.toApp,
                    data;

                try {
                    data = JSON.parse(event.data);
                } catch ( error ) {
                    data = event.data;
                }

                switch ( event.message ) {
                    case messagesToApp.openTaskManager:
                        gSTB.EnableVKButton(false);
                        gSTB.HideVirtualKeyboard();

                        callback({message: messagesToApp.openTaskManager});
                        break;
                    case messagesToApp.openSettings:
                        gSTB.EnableVKButton(false);
                        gSTB.HideVirtualKeyboard();

                        callback({message: messagesToApp.openSettings});
                        break;
                    case messagesToApp.notification:
                        callback({message: messagesToApp.notification, data: data});
                        break;
                    case messagesToApp.favoritesState:
                        callback({message: messagesToApp.favoritesState, data: data});
                        break;
                    case messagesToApp.setFavicon:
                        callback({message: messagesToApp.setFavicon});
                        break;
                    case messagesToApp.unsetFavicon:
                        callback({message: messagesToApp.unsetFavicon});
                        break;
                    case messagesToApp.setLoadProgress:
                        callback({message: messagesToApp.setLoadProgress, data: data});
                        break;
                    case messagesToApp.changeUrl:
                        callback({message: messagesToApp.changeUrl, data: data});
                        break;
                    case messagesToApp.openMenu:
                        gSTB.EnableVKButton(false);
                        gSTB.HideVirtualKeyboard();

                        callback({message: messagesToApp.openMenu, data: stbWindowMgr.GetFocusedInputInfo()});
                        break;
                    case messagesToApp.reload:
                        callback({message: messagesToApp.reload, data: data});
                        break;
                    case messagesToApp.ready:
                        callback({message: messagesToApp.ready});
                        break;
                    case messagesToApp.home:
                        gSTB.EnableVKButton(false);
                        gSTB.HideVirtualKeyboard();

                        callback({message: messagesToApp.home});
                        break;
                    case messagesToApp.back:
                        gSTB.EnableVKButton(false);
                        gSTB.HideVirtualKeyboard();

                        self.exit(event.windowId);
                        callback({message: messagesToApp.back});
                        break;
                    case messagesToApp.search:
                        gSTB.EnableVKButton(false);
                        gSTB.HideVirtualKeyboard();

                        callback({message: messagesToApp.search});
                        break;
                    case messagesToApp.mediaAvailable:
                        gSTB.EnableVKButton(false);
                        gSTB.HideVirtualKeyboard();

                        callback({message: messagesToApp.mediaAvailable, data: data});
                        break;
                }
            });
        }
    });

    window.onunload = this.exit;
}


/**
 * Send message to browser engine.
 *
 * @param {string} message - message to send in special format/information type
 * @param {*} [data] - data for transmission itself
 */
Browser.prototype.sendMessage = function ( message, data ) {
    stbWebWindow.messageSend(this.windowId, message, typeof data === 'object' ? JSON.stringify(data) : data);
};


/**
 * Full exit.
 *
 * @param {number} windowID - ID of window to close
 */
Browser.prototype.exit = function ( windowID ) {
    if ( !this.isKilled ) {
        gSTB.CloseWebWindow();
        stbWindowMgr.closeWindow(windowID || this.windowId);

        if ( this.standalone ) {
            stbWindowMgr.closeWindow(this.standaloneModePortalWindowId);
        }

        stbEvent.removeListener('message', listener);
        this.isKilled = true;
    }
};


/**
 * Initialize browser engine.
 *
 * @param {Object} [config] - url for passing into stbWindowMgr.openWebFace instead of built-in
 */
Browser.prototype.initRegular = function ( config ) {
    var engine = core.packages.filter(function ( pkg ) {
        return pkg.type === 'browser-engine';
    })[0];

    if ( config ) {
        if ( config.purpose === 'parameter' ) {
            if ( engine.url[engine.url.length - 1] === '/' ) {
                engine.url = engine.url.substring(0, engine.url.length - 1);
            }

            engine.url += '?';

            config.data.forEach(function ( param, idx ) {
                var keyValue = Array.isArray(param) ? param[0] + '=' + param[1] : param;

                engine.url += (idx === config.data.length - 1) ? keyValue : keyValue + '&';
            });
        } else {
            // full replacement
            engine.url = String(config.data);
        }
    }

    this.windowId = stbWindowMgr.openWebFace(engine.url);
    stbWindowMgr.windowHide(this.windowId);
};


/**
 * Initialize browser engine in standalone mode.
 */
Browser.prototype.initStandalone = function () {
    var url = location.protocol + '//' + location.host + location.pathname,
        urlParts, windowId;

    if ( window.location.hash === '#standaloneOff' ) {
        this.initRegular({
            purpose: 'parameter',
            data: [['portalWindowId', this.standaloneModePortalWindowId = +stbStorage.getItem('standaloneModePortalWindowId')]]
        });

        return;
    }

    if ( location.search ) {
        urlParts = location.search.substring(0).split('&');
        urlParts = urlParts.map(function ( item ) {
            return decodeURIComponent(item);
        });

        url += '?' + urlParts.join('&');
    }

    windowId = stbWindowMgr.windowInit(JSON.stringify({
        url: url + '#standaloneOff',
        x: 0,
        y: 0,
        width: screen.width,
        height: screen.height,
        visible: true
    }));

    stbStorage.setItem('standaloneModePortalWindowId', windowId);
};


/**
 * Make the "Internal Portal" window active.
 */
Browser.prototype.showPortalWindow = function () {
    stbWindowMgr.showPortalWindow();
};


/**
 * Define whole set of messages for communication between browser app and its engine part.
 */
Browser.prototype.messages = require('./messages');


module.exports = {
    onAppInit: function ( config, callback ) {
        // dome some asynchronous operations
        callback(null, new Browser(config));
    }
};
